import Select from "@/Components/Select/Select";
import useAuthHook from "@/shared/hooks/useAuthHook";
import useIsWaiterHook from "@/shared/hooks/useIsWaiterHook";
import useLayoutData from "@/shared/hooks/useLayoutData";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Spinner from "../Spinner/Spinner";
import LayoutMessage from "./LayoutMessage";
import ShareLocation from "./ShareLocation";

const LayoutLoader = () => {
  const { error } = useIsWaiterHook();
  const { signOut } = useAuthHook();
  const { t } = useTranslation();
  const {
    isPending,
    isSuccess,
    data,
    branch,
    franchise,
    setBranch,
    setFranchise,
    setMerchant,
    currentBranches,
  } = useLayoutData();

  useEffect(() => {
    if (!isSuccess) return;
    // A branch kept from an earlier session can miss its franchise id
    const storedBranch =
      branch?.id && franchise <= 0
        ? currentBranches?.find((b) => b.branch.id === branch.id)
        : undefined;
    const selected =
      storedBranch ??
      (currentBranches?.length === 1 ? currentBranches[0] : undefined);

    if (selected) {
      setFranchise(selected.franchise.id);
      setBranch(selected.branch);
      setMerchant(selected.merchant.id);
    }
  }, [
    currentBranches,
    isSuccess,
    branch?.id,
    franchise,
    setBranch,
    setFranchise,
    setMerchant,
  ]);

  return (
    <LayoutMessage>
      {error !== null ? (
        <div className="flex flex-col items-center gap-4">
          <div className="text-center text-[1.8rem]" style={{ fontWeight: "900" }}>
            {error.code === 403 ? error.message : t("locationErrorWaiter")}
          </div>
          <ShareLocation />
          <Button onClick={() => signOut()}>{t("navigation.signout")}</Button>
        </div>
      ) : isPending ||
        currentBranches?.length === 1 ||
        currentBranches?.some((b) => b.branch.id === branch?.id) ? (
        <Spinner size="0.4rem" />
      ) : (
        <div className="flex w-[30rem] items-center">
          {data ? (
            <div className="w-full">
              <div className="mt-[2rem] w-full">
                <Select
                  isMobileNative
                  menuPlacement="auto"
                  placeholder={t("selectBranch")}
                  onChange={(v) => {
                    setFranchise(v.franchise.id);
                    setBranch(v.branch);
                    setMerchant(v.merchant.id);
                  }}
                  isSearchable
                  getOptionLabel={(option) => option.branch.name}
                  getOptionValue={(option) => option.branch.id}
                  options={currentBranches}
                />
              </div>
            </div>
          ) : (
            <div>
              <div className="mb-[1rem]" style={{ backgroundColor: "" }}>
                Ververs de pagina, indien het niet verandert neemt contact op
                met appsmen
              </div>
              <Button onClick={() => signOut()}>Uitloggen</Button>
            </div>
          )}
        </div>
      )}
    </LayoutMessage>
  );
};

export default LayoutLoader;
